const POINTS = [2, 3, 3, 5, 6, 6, 8, 9, 10, 10];

export function HeroDashboard() {
  const w = 360, h = 120;
  const x = (i) => 20 + (i * (w - 40)) / (POINTS.length - 1);
  const y = (v) => h - 15 - v * 8;
  const path = POINTS.map((v, i) => `${i ? "L" : "M"}${x(i)},${y(v)}`).join(" ");
  return (
    <div className="panel shadow-[0_20px_50px_rgba(11,27,51,0.12)] fade-up" style={{ animationDelay: "0.15s" }} data-testid="hero-dashboard">
      <div className="flex items-center justify-between px-4 py-3 border-b border-[#1E2D4A]">
        <span className="font-mono text-xs text-slate-400">SGC-UPG / MILESTONE FORECAST</span>
        <span className="flex gap-1.5"><i className="w-2 h-2 bg-slate-600" /><i className="w-2 h-2 bg-slate-600" /><i className="w-2 h-2 bg-amber-500" /></span>
      </div>
      <div className="p-5 space-y-5">
        <p className="font-heading text-xl font-semibold text-slate-100">Ready for Start-Up</p>
        <div className="grid grid-cols-3 gap-px bg-[#1E2D4A]">
          {[["Target", "28 Nov", "text-slate-200"], ["Forecast", "08 Dec", "text-amber-400"], ["Variance", "+10 d", "text-red-400"]].map(([k, v, c]) => (
            <div key={k} className="bg-[#0B1222] p-3">
              <p className="font-mono text-[10px] uppercase tracking-wider text-slate-500">{k}</p>
              <p className={`num text-lg sm:text-xl font-semibold ${c}`}>{v}</p>
            </div>
          ))}
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-wider text-slate-500 mb-2">Forecast trend, last 10 weeks (days late)</p>
          <svg viewBox={`0 0 ${w} ${h}`} className="w-full h-auto">
            <line x1="20" x2={w - 20} y1={y(0)} y2={y(0)} stroke="#64748B" strokeDasharray="4 4" />
            <text x={w - 20} y={y(0) - 4} textAnchor="end" fill="#64748B" fontSize="9" fontFamily="JetBrains Mono">TARGET</text>
            <path d={path} fill="none" stroke="#F59E0B" strokeWidth="2.5" />
            {POINTS.map((v, i) => <rect key={i} x={x(i) - 2.5} y={y(v) - 2.5} width="5" height="5" fill="#F59E0B" />)}
          </svg>
        </div>
        <div className="space-y-2">
          {[["A  Mechanical completion", 91], ["B  Pre-commissioning", 58], ["C  Commissioning", 12]].map(([k, v]) => (
            <div key={k} className="flex items-center gap-3 text-xs">
              <span className="w-44 font-mono text-slate-400 truncate">{k}</span>
              <span className="flex-1 h-1.5 bg-[#1E293B]"><span className="block h-full bg-amber-500" style={{ width: `${v}%` }} /></span>
              <span className="num text-slate-300 w-9 text-right">{v}%</span>
            </div>
          ))}
        </div>
        <p className="text-xs text-slate-400 border-l-2 border-red-500 pl-3">Driver: instrumentation loop checks, 3.7 per day against 228 remaining.</p>
      </div>
    </div>
  );
}
